import React, { useState, useRef, useEffect, Fragment } from 'react';
import { Bar, Line, Chart, Pie, Scatter, Bubble } from 'react-chartjs-2';
import { Section, Time_period_selector, Select} from '../../../../components';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';









export default function Chart_component(props) {
    const [dates_back, setDatesBackFunc] = useState(0);
    const [time_frame, setTimeFrame]=useState('day_of_month');
    const [team_member, setTeamMemberFunc]=useState(undefined);
    let current_team_member = useRef(undefined);
    function setTeamMember(x) { current_team_member.current = x; setTeamMemberFunc(x); }

    let team_member_main=useRef(undefined);
    if(props.team_member!=team_member_main.current){team_member_main.current=props.team_member; setTeamMember(props.team_member);}

    let type = props.type; let sub_type = props.sub_type;
    let with_moving_average =true;
    let chart_type = (props.chart_type == undefined) ? 'line' : props.chart_type;


    function setDatesBack(d, ed = {}) {
        console.log(d, ed.time_frame, 'WOOW');
        if(ed.time_frame!=undefined){setTimeFrame(ed.time_frame);}
        setDatesBackFunc(d);
        let time_frame=props.time_frame; if (ed.time_frame!=undefined){time_frame=ed.time_frame;}
        let team_member=current_team_member.current; if (ed.team_member != undefined) { team_member = ed.team_member }
        let dates_back = d;
        let time_array = props.getTimeArray(dates_back, time_frame, props); let start_date = time_array.start_date; let end_date = time_array.end_date;
        let url = getUrl(props, start_date, end_date, time_frame, team_member);
        console.log(props, url,props.db_data[url], 'WOOW');

        if (props.db_data == undefined || props.db_data[url] == undefined) {
            props.getChartAnalyticsData(url);
        }
    }

    //GENERIC
    let ta=props.getTimeArray(dates_back, time_frame, props, 'dimension_1'); 
    let start_date=ta.start_date; let end_date=ta.end_date; let time_title=ta.time_title; let labels=ta.labels;
    console.log('LABELS 1', labels, ta);
    
    let colour_dic = {
        'primary':{ order:1, back: (props.workspace.primary_colour == undefined) ? 'rgba(0, 89, 140, 0.9)' : props.workspace.primary_colour, border: (props.workspace.primary_colour == undefined) ? 'rgba(0, 89, 140, 1)' : props.workspace.primary_colour }, 
        'secondary':{order:4, back: (props.workspace.secondary_colour == undefined) ? 'rgba(255, 94, 61, 0.9)' : props.workspace.secondary_colour, border: (props.workspace.secondary_colour == undefined) ? 'rgba(	255, 94, 61, 1)' : props.workspace.secondary_colour }, 
        'tertiary':{order:7, back: (props.tertiary_colour == undefined) ? 'rgba(0, 174, 239,1)' : props.tertiary_colour, border: (props.tertiary_colour == undefined) ? 'rgba(0, 174, 239,1)' : props.tertiary_colour }, 
        'purple': {order:6, back: 'rgba(136, 78, 255, 0.9)', border: 'rgba(136, 78, 255, 1)'}, 
        'yellow': {order:3, back: 'rgba(255, 165, 0, 0.9)', border: 'rgba(255, 165, 0, 1)'},
        'green': {order:2, back: 'rgba(102, 204, 102, 0.9)',border: 'rgba(102, 204, 102, 1)'},
        'red': {order:5, back: 'rgba(204, 0, 0, 0.9)',  border: 'rgba(204, 0, 0, 1)'},
        'black': {order:11, back: 'rgba(44, 44, 46, 0.9)', border: 'rgba(44, 44, 46, 1)'},
        'cyan': {order:8, back: 'rgba(0, 204, 204, 0.9)', border: 'rgba(0, 204, 204, 1)'},
        'magenta': {order:9, back: 'rgba(255, 51, 153, 0.9)', border: 'rgba(255, 51, 153, 1)'},
        'pink': {order:10, back: 'rgba(255, 182, 193, 0.9)', border: 'rgba(255, 182, 193, 1)'},
    };



    let owners = [{ id: 'all', name: 'Compare users' }, { id: 'all_users', name: 'All users' }]; for (let k in props.workspace_data.user_workspaces) { if (props.workspace_data.user_workspaces[k].invisible != true) { owners.push({ id: props.workspace_data.user_workspaces[k].id, name: props.workspace_data.user_workspaces[k].first_name + ' ' + props.workspace_data.user_workspaces[k].last_name }); } }
  

    useEffect(() => { props.setDatesBackFunc(setDatesBack); setDatesBack(0, {time_frame:'day_of_month'}); }, []);

    useEffect(()=>{
        setDatesBack(dates_back, {time_frame:time_frame});
    },[props.ag]);

    let url =getUrl(props, start_date, end_date, time_frame, team_member);
    console.log(url, 'WOOW');
    let total_sum = 0;
    let subject_labels = getLabel(props, props.category);
    let dimension_1 = (props.dimension_1 == undefined) ? time_frame : props.dimension_1; let dimension_1_labels = (Object.keys(labels).length)?labels:getLabel(props, dimension_1, 'dimension_1');
    let segmentation =(team_member=='all')?'user_workspace_id':props.segment; let segmentation_labels = getLabel(props, segmentation);
    let dimension_2 = props.dimension_2; let dimension_2_labels =(dimension_2==undefined)?undefined: getLabel(props, dimension_2, 'dimension_2');
    //IF IT IS A PIE CHART SEGMENTATION BECOMES THE ONE AND ONLY DIMENSION; YOU CAN HAVE MORE SEGMENTATIONS BUT WE DON'T SUPPORT IT AS OF NOW;
    if (chart_type == 'pie') { dimension_1_labels = getLabel(props, segmentation); segmentation_labels = { 'pie_chart_data': 'Data' }; dimension_1 = segmentation; segmentation = 'pie_chart_data';}
    console.log('LABLES', subject_labels, segmentation_labels);

    let datasets=[];
    //PREPARE AN INITIAL DATASET TD TO BE ABLE TO CONVERT EASILY INTO DATASETS FOR THE CHARTS;
    let td={};
    if (props.db_data[url] != undefined) {
        for (let x of props.db_data[url].data) {
            let seg =(segmentation=='pie_chart_data')?'pie_chart_data':x[segmentation]; let d2 = (dimension_2 == undefined) ? 'quantity' : x[dimension_2]; let d1 = (dimension_1 == undefined) ? 'no_dimension' : x[dimension_1]; 
            if (td[seg] == undefined) { td[seg] = {}; } if (td[seg][d1] == undefined) { td[seg][d1] = {}; } if (td[seg][d1][d2] == undefined) { td[seg][d1][d2] = 0; } td[seg][d1][d2] += x.quantity;
        }
    }

    console.log(td, segmentation_labels, 'TD');

    //NOW CREATE THE DATASETS FOR CHARTS;
    let index=0;
    let pie_background=[];
    let pie_hover=[];
    let segmentation_names=[];
    for(let seg_key in segmentation_labels){if(td[seg_key]!=undefined){
        console.log('YESSS', 'TD');
        let segment_data = []; let total_segment=0; //DIFFERENT IF WE ARE DEALING WITH BUBBLE CHART OR NOT
        if(dimension_2==undefined){let pie_index=0; for(let d1_key in dimension_1_labels){
            let quant=(td[seg_key]==undefined || td[seg_key][d1_key]==undefined)?0:td[seg_key][d1_key].quantity; 
            if(chart_type=='pie' && quant==0){}else{
                if (chart_type == 'pie') { pie_background.push(getColour(props, pie_index, colour_dic, segmentation, seg_key).back); pie_hover.push(getColour(props, pie_index, colour_dic, segmentation, seg_key).border); }
                segment_data.push(quant);
                
            }
            total_segment+=quant;
            pie_index+=1;
        } }
        else{if(td[seg_key]!=undefined){   
            for(let d1_key in td[seg_key]){    for(let d2_key in td[seg_key][d1_key]){ segment_data.push({ x: dimension_1_labels[d1_key], y: dimension_2_labels[d2_key], r: td[seg_key][d1_key][d2_key]}); total_segment += td[seg_key][d1_key][d2_key];}}
            let maxValue = Math.max(...segment_data.map(d => d.r));  // Get the maximum value from the data
            if(maxValue<10){maxValue=10;}
            let minRadius=1; let maxRadius=25;
            segment_data = segment_data.map(d => ({
                x: d.x,
                y: d.y,
                r: Math.min(Math.max(minRadius, (d.r/ maxValue) * maxRadius), maxRadius), // Scale radius
                value: d.r // Keep the actual value for tooltips
            }));
        }}
        let seg_name = getSegName(segmentation_labels[seg_key], segmentation_names);
        segmentation_names.push(seg_name);
        let dataset = { label: (type == 'tasks_overdue') ? seg_name : seg_name + ' (' + total_segment + ')', data: segment_data, order:getColour(props, index, colour_dic, segmentation, seg_key).order,  backgroundColor: (chart_type == 'pie') ? pie_background : getColour(props, index, colour_dic, segmentation, seg_key).back, hoverColor: (chart_type == 'pie') ? pie_hover : undefined, borderColor: (chart_type == 'pie') ? undefined : getColour(props, index, colour_dic, segmentation, seg_key).border, borderWidth: 1, fill: true};
        if(chart_type=='horizontal_bar'){dataset.axis='y';}
        datasets.push(dataset); 
        total_sum+=total_segment;
        }
        index += 1;
    }

    let labels_array = []; for (let labels_key in dimension_1_labels) { 
        let xx = dimension_1_labels[labels_key];
        if(chart_type=='pie' && td.pie_chart_data!=undefined && td.pie_chart_data[labels_key]!=undefined){xx=xx+' ('+td['pie_chart_data'][labels_key].quantity+')'}
        if(chart_type == 'pie' && (td.pie_chart_data == undefined || td.pie_chart_data[labels_key] == undefined)){}
        else{labels_array.push(xx);} 
    }

    let labels_2_array= ['']; if(dimension_2_labels!=undefined){for(let labels_key in dimension_2_labels){let xx = dimension_2_labels[labels_key]; labels_2_array.push(xx);}  labels_2_array.push(''); }
    let data = { labels: labels_array, datasets: datasets };
  
   
    if (chart_type == 'bar_stacked' && with_moving_average == true && props.db_data[url] != undefined && props.db_data[url].moving_averages['14_day_moving_average']!=undefined) { 
        let mm_14 = { label: '14 day MA', data: [], borderColor: 'red', borderWidth:2, backgroundColor: 'transparent', type: 'line', stack:'14_ma'}; 
        let mm_50 = { label: '50 day MA', data: [], borderColor: 'black', borderWidth:2, backgroundColor: 'transparent', type: 'line', stack:'50_ma'};
        for (let mad of props.db_data[url].moving_averages['14_day_moving_average'].total){mm_14.data.push(mad.quantity);}; 
        for (let mad of props.db_data[url].moving_averages['50_day_moving_average'].total) { mm_50.data.push(mad.quantity); };
        datasets.push(mm_14);
        datasets.push(mm_50); 
    }
   
   
    //GET CHART TITLE.
    let chart_title = '';
    if (props.workspace.admin != true) { chart_title = 'my '; } 
    if (type != 'all' && type != undefined) { chart_title += ' ' + type.replace('_', ' '); }
    else{chart_title+=' timeline items'}

    if(subject_labels!=undefined && sub_type!=undefined && sub_type!='all' && subject_labels[sub_type]!=undefined){chart_title+='('+subject_labels[sub_type]+')';}

    chart_title = chart_title.replace(/\b\w/g, (char) => char.toUpperCase());

    console.log('SL', subject_labels, data);
    return (
        <Fragment>
            <div><Section maxWidth='1200px' top='-10px' title={(chart_type == '14_moving_average_line' || type=='tasks_overdue') ? chart_title : (chart_title + ' (total: ' + total_sum + ')')} style={{ marginBottom: '50px' }} action={
                <div style={{ marginTop: '5px' }}><span style={{marginRight:'5px'}}><EditIcon color='primary' style={{cursor:'pointer'}} onClick={() => { props.setGenerateChartPopup(props.id); }} /></span><span><DeleteIcon color='error' style={{cursor:'pointer'}} onClick={() => { props.setDeleteChartPopup(props.id) }} /></span></div>}>
                {(props.workspace.admin != true) ? null : <Select no_field size='small' variant='outlined' name='user_workspace_id' value={team_member} onChange={(e) => { setTeamMember(e.target.value); setDatesBack(dates_back, { time_frame: time_frame, team_member: e.target.value }); }} style={{ width: 'calc(100% - 20px)', marginLeft: '0px', marginTop: '-10px', width: '180px', marginRight: '10px', height: '40px', position: 'absolute', right: '65px', top: '20px' }} select_data={owners} />}
                <div style={{ height: '40px' }} />
                <Time_period_selector time_title={time_title} time_frame={time_frame}  dates_back={dates_back} setTimeFrame={setTimeFrame} setDatesBack={setDatesBack} />

<div style={{ height: '10px' }} />
                {(chart_type == 'line' || chart_type == '14_moving_average_line') ? 
                    <Line data={(chart_type == '14_moving_average_line') ? data_moving_average : data} width={100} height={55} options={{ bezierCurve: (chart_type == 'moving_average_line') ? true : false, maintainAspectRatio: true, legend: { display: false }, scales: { y: { stacked: true, min: 0, suggestedMax: 20 } }, elements: { point: { radius: 0 } } }} />
                : (chart_type == 'bar' || chart_type == 'bar_stacked') ? 
                    <Bar data={data} width={100} height={55} options={{ maintainAspectRatio: true, scales: { y: { stacked: (chart_type == 'bar_stacked') ? true : false, min: 0, suggestedMax: 20 }, x: { stacked: (chart_type == 'bar_stacked') ? true : false } }, elements: { point: { radius: 0 } } }} />
                : (chart_type == 'pie') ? 
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}><div style={{ width: '100%', maxWidth: '380px', maxHeight: '340px', marginTop: '-50px' }}><Pie data={data} options={{ plugins: { legend: {position: 'left' } } }} /></div></div>
                : (chart_type == 'horizontal_bar') ? 
                    <Bar data={data} width={100} height={55} options={{ plugins: { legend: { display: true } }, scales: { y: { stacked: true }, x: { stacked: true, suggestedMax: 50, min: 0 } }, maintainAspectRatio: true, indexAxis: 'y' }} />
                : (chart_type=='bubble')?
                                    <Bubble data={data} width={100} height={55} options={{
                                        plugins:{
                                        tooltip: {
                                            callbacks: {label: function (tooltipItem) {
                                                    var datasetLabel = tooltipItem.dataset.label || '';
                                                    var dataPoint = tooltipItem.raw;
                                                    return datasetLabel.replace(/\s?\(\d+\)$/, '') + ': ' + dataPoint.x+' - '+dataPoint.y+' - '+dataPoint.value;  // Show the actual value
                                                }
                                            }
                                        }
                                        }, scales: { x: { type: 'category', labels: labels_array, ticks: { maxTicksLimit:31 } }, y:{type:'category', labels:labels_2_array, ticks:{maxTicksLimit:20}}}}}/>
                :null}
            </Section></div>
     </Fragment>
    )
}


function orderDataSets(){

}


function getUrl(props, start_date, end_date, time_frame, user_workspace_id) { 
    let dimension_1=props.dimension_1;
    let dimension_2=props.dimension_2;
    if(dimension_1==undefined){dimension_1=time_frame;}
    return '/api/analytics/chart_data/' + props.chart_id + '?subject='+props.ag.type+'+'+props.ag.category+'+'+props.ag.sub_type+'&dimension_1='+dimension_1+((dimension_2==undefined || dimension_2==null)?'':'&dimension_2='+dimension_2)+'&start_date=' + formatDate(start_date) + '&end_date=' + formatDate(end_date) + '&timezone=' + getTimezone() +'&user_workspace_id='+user_workspace_id+ ((user_workspace_id=='all')?'&segment=user_workspace_id':(props.segment == undefined) ? '' : '&segment=' + props.segment) }

function getLabel(props, x, dimension_key=undefined){ 
    if (x == null || x == 'all') { return { undefined: 'All' }; }
    else if(x==undefined){return {undefined:'All'};}
    if (x == 'time' || x == 'day_of_week' || x=='week_day') { return props.getTimeArray(1, x, props, dimension_key).labels;}
    else if (x == 'user_workspace_id') { let user_labels = {}; for (let k in props.workspace_data.all_user_workspaces) { if (props.workspace_data.all_user_workspaces[k].invisible == true){user_labels[k]='No user'}else{ user_labels[k] = props.workspace_data.all_user_workspaces[k].first_name + ' ' + props.workspace_data.all_user_workspaces[k].last_name; } } return user_labels;} 
    else if(x == 'timeline_item_type'){return props.chart_type_labels;} 
    else { let arr = {}; let z = props.chart_sub_type_labels[props.type][x]; for (let key in z) { arr[key] = (z[key].title == undefined) ? z[key] : z[key].title }; return arr;} 
}

function getColour(props, index, colour_dic, segment, seg_key){
    let colour_key = undefined; if (props.chart_sub_type_labels[props.type]!=undefined && props.chart_sub_type_labels[props.type][segment] != undefined && props.chart_sub_type_labels[props.type][segment][seg_key]!=undefined ) { colour_key = props.chart_sub_type_labels[props.type][segment][seg_key].colour;}
    console.log(colour_key, colour_dic, props, seg_key, 'COLOUR');
    return colour_dic[(colour_key!=undefined && colour_dic[colour_key]!=undefined)?colour_key:Object.keys(colour_dic)[index % Object.keys(colour_dic).length]];
}

function getSegName(seg_name, segmentation_names, index=2){ 
    if (segmentation_names.includes(seg_name)) { seg_name = seg_name + ' '+index; return getSegName(seg_name, segmentation_names, index+=1);}
    else{return seg_name;}
}

function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;
    return [year, month, day].join('-');
}